import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  getters: {
    user: state => state.user,
    children: state => state.children,
    parents: state => state.parents,
    classrooms: state => state.classrooms,
    home_url: state => state.home_url,
    logo: () => {
      return process.env.VUE_APP_PROXY + '/images/logo.jpg'
    },
    logo_mini: () => {
      return process.env.VUE_APP_PROXY + '/images/logo_mini.jpg'
    },
  },
  mutations: {
    set_data: (state, payload) => {
      state.user = payload.user
      state.children = payload.children
      state.parents = payload.parents
      state.classrooms = payload.classrooms
      state.home_url = payload.home_url
    },
    append_children: (state, payload) => {
      state.children.push(payload)
    },
    append_parent: (state, payload) => {
      state.parents.push(payload)
    }
  },
  state: {
    user: null,
    children: [],
    parents: [],
    classrooms: [],
    home_url: null
  },
  strict: process.env.NODE_ENV !== 'production',
})
